export const getAllLanguagesApi = () =>
  `${process.env.REACT_APP_API_HOST}/api/languages`;
export const getAllCategoriesApi = () =>
  `${process.env.REACT_APP_API_HOST}/api/categories`;
export const sendContactFormApi = () =>
  `${process.env.REACT_APP_API_HOST}/api/contacts`;
